import * as React from "react";
import { connect } from "react-redux";
import { ApplicationState, ConnectedReduxProps } from "@reducers/index";
import { Menu } from "@models/menu";
import { deleteRequest, fetchRequest } from "@actions/menu";
import MenusTable from "@components/menus/Table";
import { Button, Card, Col, Row } from "antd";
import TableRenderer from "@hocs/TableRenderer";
import MenuForm from "@components/menus/Form";
import { FormattedMessage } from "react-intl";
import { getMenusList } from "@reducers/menu";
import SearchMenuComponent from "@components/menus/Search";
import { NavLink } from "react-router-dom";

interface PropsFromState {
  loading: boolean;
  data: Menu[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest;
  deleteRequest: typeof deleteRequest;
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class MenusIndexPage extends React.Component<AllProps> {
  deleteMenu = (item: Menu): any => {
    this.props.deleteRequest({
      params: {
        id: item.id
      }
    });
  };

  render() {
    const { loading, data, search, currentPage } = this.props;
    return (
      <div>
        <div className={`toggle-button-wrapper`}>
          <NavLink to={`/menus/create`}>
            <Button type={"primary"}>
              <FormattedMessage
                id="app.new_menu"
                defaultMessage={`Create Menu`}
              />
            </Button>
          </NavLink>
        </div>
        <div className={"page-table-wrapper"}>
          <Card className={`page-table-header`} bordered={false}>
            <SearchMenuComponent search={search} />
          </Card>

          <MenusTable
            data={data}
            currentPage={currentPage}
            rowKey={record => record.id}
            deleteFn={this.deleteMenu}
            loading={loading}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ menus }: ApplicationState) => {
  return {
    loading: menus.loading,
    data: getMenusList(menus),
    count: menus.count
  };
};

const mapDispatchToProps = {
  fetchRequest,
  deleteRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TableRenderer(MenusIndexPage));
